import React from 'react';
import './WhyDermaProtecPage.css';

const WhyDermaProtecPage = () => {
  return (
    <div className="why-derma-protec-main">
      <section className="why-derma-protec-hero">
        <div className="why-derma-protec-hero-content">
          <h1>Why Derma Protec</h1>
        </div>
      </section>

      <section className="why-derma-protec-content">
        <div className="content-block">
          <div className="content-text">
            <h2>Performance Comparison</h2>
            <p>At Derma Protec Films, we understand that choosing the best window film for your vehicle can be overwhelming, especially with so many technical specifications on the table. To help simplify your decision, we've compiled a side-by-side comparison chart featuring Derma Protec and other international solar film brands.</p>
            <p>For a fair evaluation, all films are grouped according to similar Visible Light Transmission (VLT) percentages. This helps level the field, ensuring a realistic performance-to-performance comparison.</p>
            <p>Our chart highlights the following key metrics:</p>
            <ul>
              <li>VLT (Visible Light Transmission)</li>
              <li>UVR (Ultraviolet Rejection)</li>
              <li>TSER (Total Solar Energy Rejected)</li>
              <li>IRR (Infrared Rejection)</li>
              <li>Brand & Model Name</li>
            </ul>
          </div>
        </div>

        <div className="comparison-table-container">
          <h2>Film Performance Comparison</h2>
          <div className="comparison-table-wrapper">
            <table className="comparison-table">
              <thead>
                <tr>
                  <th>Series</th>
                  <th>Derma Protec</th>
                  <th>3M</th>
                  <th>Llumar</th>
                  <th>Xpel</th>
                  <th>Suntek</th>
                  <th>V-Kool</th>
                  <th>SolarGard</th>
                </tr>
                <tr>
                  <th>Model</th>
                  <th>Skin & Eye Care</th>
                  <th>Crystalline</th>
                  <th>IRX</th>
                  <th>XR Plus</th>
                  <th>Evolve</th>
                  <th>Solitaire</th>
                  <th>XenithIR</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>VLT</td>
                  <td>30%</td>
                  <td>33%</td>
                  <td>30%</td>
                  <td>31%</td>
                  <td>30%</td>
                  <td>36%</td>
                  <td>30%</td>
                </tr>
                <tr>
                  <td>UVR</td>
                  <td>100%</td>
                  <td>99%</td>
                  <td>99%</td>
                  <td>99%</td>
                  <td>99%</td>
                  <td>99%</td>
                  <td>99%</td>
                </tr>
                <tr>
                  <td>IRR</td>
                  <td>100%</td>
                  <td>99%</td>
                  <td>87%</td>
                  <td>96%</td>
                  <td>93%</td>
                  <td>94%</td>
                  <td>93%</td>
                </tr>
                <tr>
                  <td>TSER</td>
                  <td>81%</td>
                  <td>62%</td>
                  <td>56%</td>
                  <td>61%</td>
                  <td>58%</td>
                  <td>66%</td>
                  <td>60%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="content-block disclaimer">
          <div className="content-text">
            <h2>Transparent Comparison</h2>
            <p>We believe in transparent, meaningful comparisons — so you can make the most informed choice for your comfort, protection, and compliance.</p>
            <div className="disclaimer-box">
              <h3>📬 Disclaimer:</h3>
              <p>All performance data shown is sourced directly from official manufacturer websites. This comparison is created to assist readers in understanding product performance and selecting a film that suits their needs.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyDermaProtecPage; 